module.exports = __webpack_public_path__ + "img/[机智].dac38554.svg";